import React from "react";
import Pagination from "../../Common/Pagination";
import Table from "../../Common/Table";
import useAttendanceHistory from "./useAttendanceHistory";

const AttendanceHistory = ({ staffId }) => {
  const {
    columns,
    currentRows,
    totalRows,
    currentPage,
    rowsPerPage,
    handlePageChange,
    handleRowsPerPageChange,
  } = useAttendanceHistory(staffId);

  return (
    <>
      <div className="flex flex-col justify-start bg-white rounded-2xl px-0 sm:p-4 ">
        <h1 className="main_heading text-2xl mb-5 pl-4 mt-3 sm:pl-0">
          Attendance history
        </h1>

        <div className="mb-6 overflow-auto horizontalscroll bg-G20">
          <Table columns={columns} data={currentRows} />
        </div>

      </div>
      {/* Pagination */}
      <Pagination
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
      />
    </>
  );
};

export default AttendanceHistory;
